// Widget CSS
import '@/css/_elementor/widgets/card_widget.css';

// ..........................................................................................

// import { ShuffleColors } from '@/js/utilities/color-shuffle';

// ..........................................................................................

const colors = ['#F9D757', '#C9D0FC', '#94C3FC', '#B0EAC3', '#EB6942'];

let colorQueue = [];

function shuffle(array) {
	const arr = [...array];

	for (let i = arr.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[arr[i], arr[j]] = [arr[j], arr[i]];
	}

	return arr;
}

function getNextColor() {
	if (colorQueue.length === 0) {
		colorQueue = shuffle(colors);
	}

	return colorQueue.shift();
}

window.addEventListener('elementor/frontend/init', () => {
	elementorFrontend.hooks.addAction('frontend/element_ready/card_widget.default', (scope) => {
		const scopeEl = scope[0];

		if (!scopeEl) return;

		scopeEl.style.backgroundColor = getNextColor();
	});
});
